// src/components/list/FolderList.tsx

import { TrendingUpTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Divider,
  IconButton,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { FolderId, FolderImage, FolderName } from '@/types/domain'

import {
  useFolderAddress,
  useFolderCTime,
  useFolderImage,
  useFolderMTime,
  useFolderName,
  useFolderParent,
} from '../../hooks'

type Props = {
  id: FolderId
}

export const FolderList = ({ id }: Props) => {
  const navigate = useNavigate()

  const fName: FolderName = useFolderName(id)
  const fImage: FolderImage = useFolderImage(id)
  const fCTime = useFolderCTime(id)
  const fMTime = useFolderMTime(id)
  const parentId: FolderId = useFolderParent(id)
  const address = useFolderAddress(id)

  const onEditFolder = () => navigate(`/folder/${id}/edit`)

  const onGotoPerformance = () => navigate(`/folder/${id}/home/performance`)

  return (
    <ListItemButton onClick={onEditFolder}>
      <ListItemAvatar>
        <Avatar src={fImage} />
      </ListItemAvatar>

      <ListItemText primary={fName} secondary={address} sx={{ width: '55%' }} />

      <Divider flexItem orientation={'vertical'} />

      <ListItemText
        primary={!parentId ? 'Gebäude' : 'Untergebäude'}
        secondary={`ID: ${id}`}
        sx={{ pl: 1, width: '10%' }}
      />

      <Divider flexItem orientation={'vertical'} />

      <ListItemText
        primary={`aktualisiert: ${fMTime}`}
        secondary={`angelegt: ${fCTime}`}
        sx={{ pl: 1, width: '25%' }}
      />

      <Tooltip title={'Leistungsübersicht'}>
        <IconButton edge={'end'} onClick={onGotoPerformance}>
          <TrendingUpTwoTone />
        </IconButton>
      </Tooltip>
    </ListItemButton>
  )
}
